import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Weeks at School' },
    { value: 2, label: 'Months at School' },
    { value: 3, label: 'Year Level' },
  ],
});
